(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/helpers/normalize-competition-result.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/helpers/normalize-competition-result.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const sortTeamMembersByName = (a, b) => {
  const firstnameCompare = a.firstname.localeCompare(b.firstname);
  if (firstnameCompare === 0) {
    return a.lastname.localeCompare(b.lastname);
  }
  return firstnameCompare;
};
const normalizeCompetitionResultIndividualDraws = competitionResultDraws => competitionResultDraws.map(draw => ({
  drawNumber: draw.drawNumber,
  correctCount: draw.corrects,
  isContributing: draw.contributing,
  hasPlayed: draw.hasPlayed,
  positionChangeSinceLast: draw.positionChangeSinceLast
}));
const normalizeCompetitionResultTeamDetails = competitionResultDraws => {
  let totalCorrects = 0;
  const draws = [];
  competitionResultDraws.forEach(r => {
    if (r.contributing) {
      totalCorrects += r.corrects;
    }
    const draw = {
      drawNumber: r.round,
      correctCount: r.corrects,
      isContributing: r.contributing,
      positionChangeSinceLast: r.positionChangeSinceLast,
      contributions: r.contributions.map((c, i) => {
        const firstName = c.anonymous ? 'Anonym' : c.firstname;
        const lastName = c.anonymous ? '' : c.lastname;
        return {
          uid: window.btoa("".concat(i).replace(/\s+/g, '')),
          isAnonymous: c.anonymous,
          firstname: firstName,
          lastname: lastName,
          location: c.location,
          correctCount: c.corrects,
          isContributing: c.contributing,
          hasPlayed: c.hasPlayed
        };
      })
    };
    draw.contributions.sort(sortTeamMembersByName);
    draws.push(draw);
  });
  return [draws, totalCorrects];
};
const normalizeCompetitionResultsIndividual = competitionResult => [competitionResult.payload.competitionId, {
  uid: competitionResult.id,
  isAnonymous: competitionResult.payload.anonymous,
  firstname: competitionResult.payload.anonymous ? 'Anonym' : competitionResult.payload.firstname,
  lastname: competitionResult.payload.anonymous ? '' : competitionResult.payload.lastname,
  position: competitionResult.payload.position,
  location: competitionResult.payload.location,
  totalCorrectCount: competitionResult.payload.corrects,
  draws: normalizeCompetitionResultIndividualDraws(competitionResult.payload.details)
}];
const normalizeCompetitionResultsTeam = competitionResult => {
  const _normalizeCompetition = normalizeCompetitionResultTeamDetails(competitionResult.payload.details),
    _normalizeCompetition2 = _slicedToArray(_normalizeCompetition, 2),
    draws = _normalizeCompetition2[0],
    totalCorrects = _normalizeCompetition2[1];
  return [competitionResult.payload.competitionId, {
    uid: competitionResult.id,
    name: competitionResult.payload.name,
    position: competitionResult.payload.position,
    totalCorrectCount: totalCorrects,
    draws
  }];
};
const CompetitionForm = {
  Individual: 'Individual',
  Team: 'Team'
};
const normalizeCompetitionResults = competitionResults => {
  const result = {};
  const getCompetitionModel = competitionId => {
    if (!result[competitionId]) {
      result[competitionId] = {
        Teams: {
          totalCount: undefined,
          result: {}
        },
        Individuals: {
          totalCount: undefined,
          result: {}
        }
      };
    }
    return result[competitionId];
  };
  if (competitionResults !== null && competitionResults !== void 0 && competitionResults.result) {
    competitionResults.result.forEach(r => {
      if (r.payload.competitionForm === CompetitionForm.Individual) {
        const _normalizeCompetition3 = normalizeCompetitionResultsIndividual(r),
          _normalizeCompetition4 = _slicedToArray(_normalizeCompetition3, 2),
          competitionId = _normalizeCompetition4[0],
          parsedR = _normalizeCompetition4[1];
        const competitionModel = getCompetitionModel(competitionId);
        competitionModel.Individuals.result[parsedR.uid] = parsedR;
        competitionModel.Individuals.totalCount = competitionResults.totalCount;
      } else {
        const _normalizeCompetition5 = normalizeCompetitionResultsTeam(r),
          _normalizeCompetition6 = _slicedToArray(_normalizeCompetition5, 2),
          competitionId = _normalizeCompetition6[0],
          parsedR = _normalizeCompetition6[1];
        const competitionModel = getCompetitionModel(competitionId);
        competitionModel.Teams.result[parsedR.uid] = parsedR;
        competitionModel.Teams.totalCount = competitionResults.totalCount;
      }
    });
  }
  return result;
};
if (svs.isServer) {
  module.exports = normalizeCompetitionResults;
} else {
  setGlobal('svs.components.marketplaceCompetition.services.helpers.normalizeCompetitionResults', normalizeCompetitionResults);
}

 })(window);